import { action, makeObservable } from 'mobx';
import _map from 'lodash/map';
import {
	BaseListViewStore,
	UsernameCellData,
	DateTimeCellData,
	ProductHistoryLogSkuCellData,
	HistoryPropertyCellData,
} from 'core/stores';
import { TableMethodInject, TableColumnEllipsis } from 'core/components';
import { historyLogSource } from 'common/constants';
import { translate } from 'core/utils';
import { ProductStore } from 'modules/product/stores';

class ProductHistoryLogViewStore extends BaseListViewStore {
	constructor(rootStore) {
		super(rootStore, {
			listStore: new ProductStore(rootStore),
			queryParams: { embed: ['user', 'product', 'product.productVirtualSkus', 'product.box'] },
			findFunction: 'findProductHistoryLog',
			routes: {
				list: () => this.rootStore.routerStore.goTo('master.app.main.product.list'),
			},
			tableData: {
				columns: [
					{
						key: 'user.displayName',
						dataCell: UsernameCellData,
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.UPDATEDBY',
						width: '120px',
						sortable: false,
					},
					{
						key: 'dateCreated',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.DATECREATED',
						dataCell: DateTimeCellData,
						sortable: false,
						dateFormat: 'LLL',
						useLocalTime: true,
					},
					{
						key: 'userAction',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.USERACTION',
						row: TableMethodInject,
						sortable: false,
						width: '100px',
						extra: ({ item, column }) => translate('PRODUCTVIEW.HISTORYLOG.LIST.ACTIONS.' + item[column.key]),
					},
					{
						key: 'productName',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.PRODUCTNAME',
						row: TableMethodInject,
						sortable: false,
						width: '400px',
						extra: ({ item }) => TableColumnEllipsis({ item: item.product, column: { key: 'name', maxChars: 100 } }),
					},
					{
						key: 'product.productVirtualSkus[0].sku',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.PRODUCTSKU',
						dataCell: ProductHistoryLogSkuCellData,
						onClick: item => this.openDetailPage(item.product.id),
						sortable: false,
						width: '169px',
					},
					{
						key: 'name',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.PROPERTY',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 500,
					},
					{
						key: 'initialValue',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.OLDVALUE',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 200,
					},
					{
						key: 'newValue',
						title: 'PRODUCTVIEW.HISTORYLOG.LIST.NEWVALUE',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 200,
					},
				],
				actions: {},
				sortObject: [],
			},
		});
		makeObservable(this);
		this.queryUtility.initialize(this.findProductHistoryLog);
	}

	openDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
			id,
		});
	};

	@action.bound
	findProductHistoryLog = async () => {
		this.suspend();
		let filter = this.queryUtility.filter;
		filter.source = String(historyLogSource.product);
		if (this.rootStore.routerStore.routerState.params.id) {
			filter.itemId = String(this.rootStore.routerStore.routerState.params.id);
		}
		if (filter.orderBy === null && filter.orderDirection === null) {
			filter.orderBy = 'dateCreated';
			filter.orderDirection = 'desc';
		}
		await this.listStore.findProductHistoryLog(filter);
		if (this.listStore.response.item.length === 0 && this.listStore.response.page !== 1) {
			await this.queryUtility.changePage(1);
		}
		this.queryUtility.handleResponse(this.listStore.response);
		// When history log data is rendered, go back to previous route (reset to initial route when modal was opened).
		this.rootStore.historyAdapter.goBack();
		this.resume();
	};
}

export default ProductHistoryLogViewStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/ProductHistoryLogViewStore.js